import { useQuery } from '@tanstack/react-query';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { User } from '../types/user';

function useCurrentUser(hasLoggedOut: boolean) {
  const getAuthenticatedUser = async () => {
    if (hasLoggedOut) {
      return undefined;
    }

    const currentUser = await getCurrentUser();

    if (!currentUser) {
      return undefined;
    }

    const auth = await fetchAuthSession({ forceRefresh: true });

    const idToken = auth.tokens?.idToken?.toString();
    const user: User = {
      username: currentUser.username,
      name: auth.tokens?.idToken?.payload.name?.toString(),
      email: auth.tokens?.idToken?.payload.email?.toString(),
      userId: currentUser.userId,
      subscriptionStatus: auth.tokens?.idToken?.payload['custom:subscriptionStatus']?.toString(),
      idToken
    };

    return user;
  };

  return useQuery({
    queryKey: ['user', hasLoggedOut],
    queryFn: getAuthenticatedUser,
    enabled: !hasLoggedOut,
  });
}

export default useCurrentUser;